import {
  Box,
  Button,
  IconButton,
  Switch,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import React, { useEffect, useMemo, useState } from "react";
import { RiDeleteBinLine, RiFileEditLine } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import CTable from "../../../components/Table/table";
import { openAddVideoFielsModel, openCreateVideos } from "../../../modules/admin-modules/models/Actions";
import { deleteVideoRequest, suspendVideoRequest } from "../../../modules/admin-modules/videos/Actions";
import VideoPreviewModal from "./videoPreviewModal";

const C = {
  primary: "#6A1E1E",
  secondary: "#4A0F1F",
  border: "#D8CEC3",
};

const iconBtnProps = {
  variant: "ghost",
  border: "0",
  size: "sm",
  color: C.primary,
  _hover: { bg: "rgba(106, 30, 30, 0.08)", color: C.secondary },
};

const VideosTable = ({ setAdd, setSelectedData, searchTerm = "" }) => {
  const videos = useSelector((state) => state.videos.videos);
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.videos.isLoading);
  const [, setPage] = useState(0);
  const [size, setPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [previewVideo, setPreviewVideo] = useState(null);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const list = useMemo(() => {
    const raw = Array.isArray(videos) ? videos : [];
    const q = (searchTerm || "").trim().toLowerCase();
    if (!q) return raw;
    return raw.filter(
      (v) =>
        v?.title?.toLowerCase().includes(q) ||
        v?.chapter?.name?.toLowerCase().includes(q)
    );
  }, [videos, searchTerm]);

  useEffect(() => {
    setPageNumber(0);
  }, [searchTerm]);

  const viewData = (row) => {
    const plain = list.find((v) => v.id === row?.id) ?? row;
    setSelectedData(plain);
  };

  const Data = list.map((data) => ({
    ...data,
    id: data?.id,
    title: data?.title,
    chapter_id: data?.chapter?.id,
    chapter_name: data?.chapter?.name,
    suspend: (
      <Box onClick={(e) => e.stopPropagation()}>
        <Switch
          colorScheme="red"
          isChecked={data?.suspended === 1}
          onChange={() => {
            const formData = new FormData();
            formData.append("_method", "PUT");
            formData.append("suspended", data?.suspended === 1 ? 0 : 1);
            dispatch(
              suspendVideoRequest({
                formData,
                id: data?.id,
              })
            );
          }}
        />
      </Box>
    ),
    publish_val: (
      <Text fontWeight="700" color={data?.publish === 0 ? C.muted : C.primary} w="70px">
        {data?.publish === 0 ? "Draft" : "Published"}
      </Text>
    ),
    add_fiels: (
      <Button
        bg={C.primary}
        color="white"
        size="sm"
        borderRadius="full"
        fontWeight="800"
        _hover={{ bg: C.secondary }}
        onClick={(e) => {
          e.stopPropagation();
          setSelectedData(data);
          dispatch(openAddVideoFielsModel());
        }}
      >
        Add files
      </Button>
    ),
    edit: (
      <IconButton
        {...iconBtnProps}
        aria-label="Edit video"
        fontSize="20px"
        icon={<RiFileEditLine />}
        onClick={(e) => {
          e.stopPropagation();
          setSelectedData(data);
          setAdd(false);
          dispatch(openCreateVideos());
        }}
      />
    ),
    delete: (
      <IconButton
        {...iconBtnProps}
        aria-label="Delete video"
        fontSize="20px"
        icon={<RiDeleteBinLine color="#9b2c2c" />}
        onClick={(e) => {
          e.stopPropagation();
          dispatch(deleteVideoRequest(data?.id));
        }}
      />
    ),
    view: (
      <Button
        bg={C.primary}
        color="white"
        size="sm"
        borderRadius="full"
        fontWeight="800"
        _hover={{ bg: C.secondary }}
        onClick={(e) => {
          e.stopPropagation();
          viewData(data);
          setPreviewVideo(data);
          onOpen();
        }}
      >
        Preview
      </Button>
    ),
  }));

  const columns = [
    { Header: "Title", accessor: "title" },
    { Header: "ID", accessor: "id" },
    { Header: "Chapter", accessor: "chapter_name" },
    { Header: "Files", accessor: "add_fiels" },
    { Header: "Publish", accessor: "publish_val" },
    { Header: "Suspended", accessor: "suspend" },
    { Header: "Edit", accessor: "edit" },
    { Header: "Delete", accessor: "delete" },
    { Header: "Preview", accessor: "view" },
  ];

  const totalPage = Math.max(1, Math.ceil(list.length / size));

  return (
    <>
      <Box px={{ base: 4, md: 8 }} pb={10} w="100%">
        <Box
          bg="rgba(255,255,255,0.9)"
          border="1px solid"
          borderColor={C.border}
          borderRadius="16px"
          overflow="hidden"
          boxShadow="sm"
        >
          <CTable
            selectedData={viewData}
            Columns={columns}
            Data={Data}
            path="openModel"
            Title=""
            subTitle=""
            btnTitle=""
            placeHolder=""
            noSearchBar
            noFilter
            footerBtnTitle
            filterList
            addButton
            addButtonTitle=""
            setPage={setPage}
            setPerPage={setPerPage}
            currentpage={pageNumber}
            setPageNumber={setPageNumber}
            noSecondSearchBar
            isLoading={isLoading}
            perPage={size}
            totalPage={totalPage}
            wrapperProps={{ maxH: "unset", overflow: "auto" }}
            tableProps={{ bg: "transparent", borderRadius: "0", mb: 0 }}
            theadProps={{ bg: "#D8CEC3", color: "#4A0F1F" }}
          />
        </Box>
      </Box>
      <VideoPreviewModal isOpen={isOpen} onClose={onClose} videoData={previewVideo} />
    </>
  );
};

export default VideosTable;
